/**
 * Created by Daniel on 12/24/2019
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../../../widgets/widgets.module';
import { QuickTaskComponent } from './quick-task.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FieldModule } from '../../field/field.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        FormsModule,
        ReactiveFormsModule,
        DropDownsModule,
        DateInputsModule,
        FieldModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
    ],
    declarations: [
        QuickTaskComponent,
    ],
    exports: [
        QuickTaskComponent,
    ],
    providers: []
})
export class QuickTaskModule { }
